function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

export var entries = function entries(obj) {
  return Object.keys(obj).reduce(function (es, k) {
    return [].concat(_toConsumableArray(es), [[k, obj[k]]]);
  }, []);
};
export var isArray = function isArray(x) {
  return typeOf(x) === "array";
};
export var isFunction = function isFunction(x) {
  return typeOf(x) === "function";
};
export var isObject = function isObject(x) {
  return typeOf(x) === "object";
};
export var isUndefined = function isUndefined(x) {
  return typeOf(x) === "undefined";
};
export var typeOf = function typeOf(x) {
  return {}.toString.call(x).match(/\s([a-z|A-Z]+)/)[1].toLowerCase();
};